import React from "react";
import EventNoteIcon from "@mui/icons-material/EventNote";
import { useCheckoutBasicDetailsContext } from "repoV2/features/CheckoutPages/modules/CheckoutBasicDetailsContextProvider";
import TimezoneSelector from "../TimezoneSelector/TimezoneSelector";
import styles from "./SessionDetailsFormGroupHeader.module.scss";
import { getSessionDetailsHeader } from "../../SessionDetailsFormGroup.constants";

const SessionDetailsFormGroupHeader = (props: {
    timezoneFieldName: string;
    classesCount: number;
}) => {
    const { timezoneFieldName, classesCount } = props;
    const { listingType } = useCheckoutBasicDetailsContext();
    return (
        <div className={styles.Wrapper}>
            <div className={styles.titleContainer}>
                <EventNoteIcon className={styles.iconStyle} />
                <div className={styles.TitleText}>
                    {getSessionDetailsHeader({ listingType, classesCount })}
                </div>
            </div>
            <TimezoneSelector timezoneFieldName={timezoneFieldName} />
        </div>
    );
};

export default SessionDetailsFormGroupHeader;
